export const ToastConstants = {
  ADD_ERROR_TOAST: 'ADD_ERROR_TOAST',
  ADD_SUCCESS_TOAST: 'ADD_SUCCESS_TOAST',
  CLEAR_ALL_TOASTS: 'CLEAR_ALL_TOASTS',
} as const

export type ToastConstantType = typeof ToastConstants[keyof typeof ToastConstants]
